import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import AddIcon from '@material-ui/icons/Add';
import { dateFormatUtil } from '../Utilities';
import Checkbox from '@material-ui/core/Checkbox';
import { TRUE } from 'sass';

class MasterGiftCards extends React.Component {
    _isMounted = false;
    state = {
        perPage: 25,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        showOrders:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'title',
        selectedItem:[],

        modalShow: false,
        alert: 0,
        alertMessage: '',
        MGCdata: [],
        selectedRow: [],
        amount:0,
        balance:0,
        title:'',
        loading:true,
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        
        this._isMounted = true;
        this.loadData();
        this.getAssignedGC();
    }

    async getAssignedGC(){
        let dataRow = {
            UniqeID: this.props.UniqeID,
            UserRole: this.props.selectedUserRole,
        };
        await RestServices.getAssignedGiftCards(
            localStorage.getItem('FirebaseToken'),
            dataRow
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted) {
                    this.setState({ selectedItem: responseData.selectedGC });
                }
            })

    }
    async loadData() {
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            userRole: 'Admins',
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: this.state.StartAt,
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        
        await RestServices.getAllMasterGiftCards(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
               
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error,
                            loading: false,
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            MGCdata: responseData.list,
                            loading: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({loading: false, alert: 1, alertMessage: err.message });
                }
            });
    }

    
    
    

      handleCheckboxChange = (event) => {
        let selectedItem =this.state.selectedItem;
        
        if(selectedItem.indexOf(event.target.name) !== -1)  
            { 
                for( var i = 0; i < selectedItem.length; i++){ 
                if ( selectedItem[i] === event.target.name) { 
                    selectedItem.splice(i, 1); 
                    i--; 
                }
            } 
           }else{
                selectedItem.push(event.target.name)
            }
            if (this._isMounted) {
                this.setState({ selectedItem:selectedItem });
            }
    };
    
    
    UpdateGiftCards = () => {
        if (this._isMounted) {
            this.setState({ loading: true });
        }
        let dataRow = {
            UniqeID: this.props.UniqeID,
            UserRole: this.props.selectedUserRole,
            selectedGC :this.state.selectedItem
        };
        
         RestServices.updateAssignedGiftCards(
            localStorage.getItem('FirebaseToken'),
            dataRow
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 2,
                            alertMessage: 'Gift Cards Updated...'
                        });
                    }
                }
            })

    }
    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {}
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.loading && <Spinner animation="border" />}

                
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Assign Master Gift Card 
                            </h4>
                        </Row>
                        <div>
                            <hr />
                           
                        </div>
                        

                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Master Gift Cards"
                            columns={[
                                {
                                    title: 'Title',
                                    field: 'title'
                                },
                                { title: 'Status', field: 'balance',
                                render: (row) => (
                                    <div>
                                        <Checkbox
                                            label={row.title}
                                            key={row.title}
                                            name={row.title}
                                            checked={this.state.selectedItem.indexOf(row.title) !== -1}
                                            onChange={this.handleCheckboxChange}
                                        />
                                    </div>
                                ) },
                                
                            ]}
                            data={this.state.MGCdata}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                           
                        </div>
                        <Form.Row>
                    <Button
                        variant="primary"
                        type="submit"
                        onClick={this.UpdateGiftCards}
                    >
                        Update Gift Cards
                    </Button>
                    
                </Form.Row>

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                
            </Container>
        );
    }
}

export default MasterGiftCards;
